export interface Member {
  name: string
  phone: string
  kakao: string
  joinType: string
  joined: string
  grade: string
  status: string
  drum: number
  cognitive: number
  report: string
  account: string
}

// NOTE: 실제 회원 목록은 `/admin/members` API로부터 로드합니다.
// 목업 데이터는 제거하고, UI는 서버 응답을 기준으로 동작합니다.
export const members: Member[] = []

export const memberGradeOptions = ['일반', '드러머', '인지', '플러스']
export const memberJoinTypeOptions = ['카카오', 'iOS(추후 적용)']
export const memberStatusOptions = ['구독 중', '미구독']

export const membersSpecification = {
  title: '회원관리',
  purpose: '회원 계정, 가입 경로, 구독 상태와 이용 이력을 관리합니다.',
  functions: [
    '회원명·등급·OS 유형·기간으로 대상 회원을 찾습니다.',
    '회원 상세에서 드럼 Raw 로그와 인지 리포트 이력을 새 창으로 확인합니다.',
    'iOS 가입은 현재 화면 구성만 되어 있으며 실제 가입 연동은 추후 적용합니다.',
  ],
  connections: [
    '결제내역 확인하기는 구독관리로 이동해 해당 회원명과 1년 기간을 자동 적용합니다.',
    '구독 상태는 구독관리의 스토어 검증 결과를 기준으로 표시합니다.',
  ],
  app: '현재 가입 연동은 Android 기준입니다. iOS 가입 화면은 추후 동일한 회원 식별값·등급·권한 정책으로 연동합니다.',
}

export const membersDataModelGuide = [
  '회원 키: member_id 또는 인증 공급자 식별자(provider_user_id)',
  '필수 속성: OS 유형, 가입일, 등급 코드, 계정 상태',
  '연계 키: member_id로 구독, 결제, Raw 로그, 인지 리포트를 조회합니다.',
]

export const membersImplementationGuide = [
  '화면 식별자: members. 좌측 사이드 메뉴는 유지하고 메인 영역만 전환합니다.',
  '필수 데이터: 회원 식별값, OS 유형, 가입일, 등급, 구독 상태, 드럼·인지 이용 이력.',
  '검색, OS 유형, 가입일, 등급 필터를 회원 목록과 결과 수에 함께 반영합니다.',
  '상세·계정 제어·결제내역 이동은 member_id를 전달해 해당 회원만 조회합니다.',
  '현재 화면은 운영 UI 목업입니다. 실제 개발에서는 API 응답, 저장 성공·실패, 권한 오류, 빈 목록 상태를 별도로 구현해야 합니다.',
]

export const membersStateDefinitions: [string, string, string][] = [
  ['정상', '회원 계정 이용 가능', '로그인과 허용된 콘텐츠 이용 가능'],
  ['이용 제한', '운영자가 제한 사유를 기록한 계정', '로그인 또는 콘텐츠 이용을 제한'],
  ['iOS 추후 적용', 'iOS 가입 화면만 구성', '실제 가입·권한 연동은 실행하지 않음'],
]
